import { useCallback, useEffect, useState } from "react";
import { getResourceSearch } from "../../lib/api";
import { useSelector, useDispatch } from 'react-redux';
import { updateResourceSearch } from '../../redux/resourcesearchSlice';
import LoadingSpinner from "../UI/LoadingSpinner";
import { useHistory } from "react-router-dom";

const ThinkBeyound = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { resourcesearchList } = useSelector((state) => state.resourcesearch);
    const [isLoading, setIsLoading] = useState(false);
    const keywordsendRequest = useCallback(() => {
        setIsLoading(true)
        getResourceSearch()
            .then((response) => {
                dispatch(updateResourceSearch(response));
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false)
            });
    }, [dispatch]);

    useEffect(() => {
        if (resourcesearchList === null || resourcesearchList.length === 0) {
            keywordsendRequest();
        }
    }, [keywordsendRequest, resourcesearchList]);

    const handleResourceSearch = (tid) => {        
        if(tid) {      
          history.push('/resourcedetail/'+tid);
        }      
    } 

    return (
        <section className="section thinkBeyoundSection">
            {isLoading && (
                <div className="parentDisable">
                    <LoadingSpinner />
                </div>
            )}
            <div className=" bg-[#fff]  bg-cover px-5 sm:px-5 md:px-5 lg:px-14 py-8 sm:py-8 md:py-8 lg:py-14">
                <h2 className="text-[#333] text-lg barlowBold leading-5 sm:text-2xl sm:leading-9 sm:tracking-[-0.25px] uppercase">What resources are you looking for?</h2>
                <div className="peersSearchList mt-6 sm:mt-8 gap-2 sm:gap-4 flex justify-center *:text-[#333] *:text-sm *:font-medium *: leading-6 *:tracking-[-0.25px] *:sm:text-base *:md:text-xl *:md:leading-8 *:sm:tracking-[-0.25px] *:sm::px-5 *:sm:py-[5px] *:px-[10px] *:py-1 *:rounded-lg *:border *:border-[#7DA1C4] *:whitespace-nowrap flex-wrap *:bg-[#F5F9FD] *:cursor-pointer max-w-full md:max-w-[80%] mx-auto">
                    {resourcesearchList && resourcesearchList.map((details) =>
                        <span key={details.tid} id={details.name} onClick={() => handleResourceSearch(details.tid)}>{details.name}</span>
                    )}
                </div>
            </div>
        </section>
    )
}

export default ThinkBeyound